import { render, staticRenderFns } from "./PeopleCard.vue?vue&type=template&id=0a458665"
import script from "./PeopleCard.vue?vue&type=script&lang=js"
export * from "./PeopleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports